import {useCallback, useState} from 'react';

import {readHeadersPanelExpanded, writeHeadersPanelExpanded} from 'features/http/lib/requestHeadersPanelState';

export const useHeadersPanelExpanded = () => {
    const [expanded, setExpanded] = useState(readHeadersPanelExpanded);

    const toggle = useCallback(() => {
        setExpanded(prev => {
            writeHeadersPanelExpanded(!prev);
            return !prev;
        });
    }, []);

    return {expanded, toggle};
};

export default useHeadersPanelExpanded;
